<template>
  <transition name="fade">
    <div
      :class="loadingClasses"
      :style="{ position: positionStyle, height: heightStyle }"
    >
      <div class="loading_center">
        <v-progress-circular
          color="#0075c2"
          :size="60"
          :width="5"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isFixed: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: '100vh',
    },
    classes: {
      type: String,
      default: '',
    },
  },
  computed: {
    loadingClasses() {
      return 'loading ' + this.classes;
    },
    positionStyle() {
      return this.isFixed ? 'fixed' : 'static';
    },
    heightStyle() {
      return this.height;
    },
  },
};
</script>

<style lang="scss">
.loading {
  top: 0;
  left: 0;
  background-color: var(--color-white);
  width: 100%;
  visibility: visible;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  &_center {
    width: 100px;
    height: 100px;
    border-radius: 16px;
    box-shadow: 0 0 99px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &_circle {
    display: block;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    animation-duration: 1.5s;
    animation-name: fades;
    animation-iteration-count: infinite;
    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
    &-cyan {
      background-color: #55bfb4;
    }
    &-purple {
      background-color: #6c86ce;
    }
    &-orange {
      background-color: #ffd46a;
    }
  }
  @keyframes fades {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
  &.api-loading {
    background-color: rgb(0 0 0 / 15%);
  }
}
</style>
